import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchAllModels } from "#modules/models/infra/fetchAllModels.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const allModelsQuery = () => ({
  queryKey: queryKeys.models.all,
  queryFn: () => fetchAllModels(),
  staleTime: STALE_TIME,
});
